import styled from 'styled-components';

import { InputProps } from './Input';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.dark};
  transition: color 0.3s ease;
`;

export const StyledInput = styled.input<InputProps>`
  height: 2.81rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  padding: 0 1rem;
  outline: none;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.dark};
  background-color: ${({ theme, disabled }) => (disabled ? theme.lightGrey : theme.background)};
  transition: all 0.3s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};

  &::placeholder {
    color: ${({ theme }) => theme.midGrey};
    opacity: 0.6;
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.midGrey};
  }

  &:focus {
    border-color: ${({ theme }) => theme.primary || '#007bff'};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.lightGrey};
  }

  &:disabled {
    border-color: ${({ theme }) => theme.grey};
    color: ${({ theme }) => theme.midGrey};
    opacity: 0.6;
  }
`;
